module.exports = __webpack_public_path__ + "img/everest.c8c2992b.png";